/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Reference to a specific task submission within a module submission
 */
export interface TaskSubmissionReference {
  /** Student user ID */
  userId: string;
  /** Course ID */
  courseId: string;
  /** Module ID */
  moduleId: string;
  /** Task ID */
  taskId: string;
}
